// extracted by css-extract-rspack-plugin
export default {"wrapper":"CpcFlexibleBuilderPage-module__wrapper--b3zVD"};